/*
 * @Author: liyihui
 * @Date:
 * @description:  接口请求访问地址 配置项相关接口
 * @Last Modified by:
 * @Last Modified time:
 */

import { microRefcdGET, microRefcdPOST, microRefcdPUT, microRefcdDEL } from './index';


// 获取版本号
function getWebVersion(data, func) {
	microRefcdGET('refgrp/WEB_VERSION/refcd', data, func);
}

const API = {
    getWebVersion,
}

export default API;



// WEBPACK FOOTER //
// ./src/api/microRefcd/refgrp.js